import React from 'react';
import { connect } from 'react-redux';
import { create } from '../Actions/channel';
import Routes from '../Shared/routes';
import AddChannel from '../Components/Channel/Item';
import { FILL_PARAMS_ERROR } from '../Shared/errors';
import { IChannelEdit } from '../Shared/interfaces';


interface IProps {
    isLoading: boolean;
    error: number | null;
    getList: () => void;
    create: (data: IChannelEdit) => void;
    history: any;
}

interface IState {
    error: number | null;
}

class AddChannelPage extends React.Component<IProps, IState> {

    state = {
        error: null
    }

    onSubmit = async (data: IChannelEdit) => {
        if (!data.name) {
            this.setState({
                error: FILL_PARAMS_ERROR
            })
        }
        else {
            await this.props.create(data);
            if (!this.props.error) {
                this.props.history.push(Routes.CHANNEL_LIST)
            }
        }
    }

    render() {
        return (
            <AddChannel
                error={this.props.error || this.state.error}
                isLoading={this.props.isLoading}
                onSubmit={this.onSubmit}
            />
        );
    }
}

function bindAction(dispatch: any) {
    return {
        create: (data: IChannelEdit) => dispatch(create(data))
    };
}

const mapStateToProps = (state: any) => {
    return {
        isLoading: state.channel.isLoading,
        error: state.channel.error
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(AddChannelPage);
